module.exports = __webpack_public_path__ + "static/media/not-found.624d3a3c.svg";